/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:41
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-25 10:26:27
 * @FilePath: \mrc-base-server-view\src\lang\langList.js
 */
let langList = [
  {
    text: "简体中文",
    value: "zh"
  },
  {
    text: "English",
    value: "en"
  }
]

export default langList